import { render, staticRenderFns } from "./HelpButtonV2.vue?vue&type=template&id=a00c18f4&scoped=true&"
import script from "./HelpButtonV2.vue?vue&type=script&lang=js&"
export * from "./HelpButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./HelpButtonV2.vue?vue&type=style&index=0&id=a00c18f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a00c18f4",
  null
  
)

export default component.exports